import script from "./mobileDateStore.vue?vue&type=script&setup=true&lang=js"
export * from "./mobileDateStore.vue?vue&type=script&setup=true&lang=js"

import "./mobileDateStore.vue?vue&type=style&index=0&id=882e9e2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-882e9e2a"]])

export default __exports__